import { create } from 'zustand'

import { ApplicationPaginated } from '../hooks/usePaginateApplications'

interface SelectedApplicationStore {
  application: ApplicationPaginated | null
  setApplication: (application: ApplicationPaginated | null) => void
}

export const useSelectedApplicationStore = create<SelectedApplicationStore>(
  (set) => ({
    application: null,
    setApplication: (application) => set({ application }),
  }),
)
